import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetEstablishmentFieldRequestsProps } from "@/services/establishment-field-request.service";
import dayjs, { Dayjs } from "dayjs";

export interface EstablishmentFieldRequestFilterForm {
  fecha?: Dayjs;
  account_number?: Option;
  tipo_operacion?: number;
  estados?: number[];
}

export const getEstablishmentFieldRequestsFilter = (
  event: EstablishmentFieldRequestFilterForm,
): Partial<GetEstablishmentFieldRequestsProps> => {
  return {
    ...(event?.fecha && dayjs(event?.fecha).isValid()
      ? { Fecha: dayjs(event?.fecha).toISOString() }
      : {}),
    ...(event?.account_number?.value
      ? { CuentaOrigen: Number(event?.account_number?.value) }
      : {}),
    ...(event?.tipo_operacion ? { TipoOperacion: Number(event?.tipo_operacion) } : {}),
    ...(event?.estados?.length ? { Estados: event?.estados } : {}),
  };
};
